export default __webpack_public_path__ + "static/PC_1_2-4ccff55a7d1ea51534f2e5dbbf052ee7.png";